module.exports = __webpack_public_path__ + "static/img/justyn-warner-529957-unsplash.fd4eb90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/justyn-warner-529957-unsplash.svg
// module id = se98
// module chunks = 37